import { Page } from "@/models/page-models/Page";

export const DailyInvoices: Page = {
  "path": "daily-invoices",
  "name": "Daily Invoices",
  "props": {
    "data": {
      "title": "Daily Invoices",
      "printable": "FALSE",
      "url": "daily-invoices",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.startDate",
                  "label": "Start Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.endDate",
                  "label": "End Date",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load Daily Invoices",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "getDailyInvoices"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Daily Invoices",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.dailyInvoices}}",
                  "items": "fetchedData.dailyInvoices.data",
                  "headers": [
                    {
                      "value": "typeIdOrInvoiceNo",
                      "text": "Doc #",
                      "type": "url",
                      "url": "fn(CONDITIONAL,{{'{{__item.invpType}}'=='Credit Note'}},/credit-note/{{__item.invoiceNo}},/invoice/{{__item.invoiceNo}})"
                    },
                    {
                      "value": "loadingManifestNo",
                      "text": "Loading Manifest #"
                    },
                    {
                      "value": "type",
                      "text": "Type"
                    },
                    {
                      "value": "transactionDate",
                      "text": "Transaction Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.transactionDate}})"
                    },
                    {
                      "value": "customerId",
                      "text": "Customer Id"
                    },
                    {
                      "value": "customerName",
                      "text": "Customer"
                    },
                    {
                      "value": "totalSR",
                      "text": "Total SAR",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{{{__item.type}}}},'),==,'INVP'),fn(SUBTRACT,0,{{__item.totalSR}}),{{__item.totalSR}}))"
                    },
                    {
                      "value": "typeOfDelivery",
                      "text": "Type of Delivery"
                    },
                    {
                      "value": "driverName",
                      "text": "Driver Name"
                    },
                    {
                      "value": "truckNo",
                      "text": "Truck #"
                    }
                  ],
                  "tableType": "static"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "functions": [
      {
        "name": "getDailyInvoices",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/reports/daily-invoices?endDate={{formData.endDate}}&startDate={{formData.startDate}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.dailyInvoices"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": false
}